<div>
  @if (warning) {
    <div class="rounded-md bg-yellow-50 p-2 mb-1">
      <div class="flex">
        <div class="shrink-0">
          <svg
            viewBox="0 0 20 20"
            fill="currentColor"
            data-slot="icon"
            aria-hidden="true"
            class="size-5 text-yellow-400"
          >
            <path
              d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
              clip-rule="evenodd"
              fill-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-yellow-800">Attention needed</h3>
          <div class="mt-2 text-sm text-yellow-700">
            <p>
              {{ warning }}
            </p>
          </div>
        </div>
      </div>
    </div>
  }
  <app-label-with-help for="textArea" class="primary-label" [fieldConfigurationAddress]="fieldConfigurationAddress"
    >{{ label }}
    @if (isTranslatable) {
      <app-language-icon [size]="5" class="ms-2 text-amazone-orange"></app-language-icon>
    }
  </app-label-with-help>

  <div class="relative">
    <textarea
      id="textArea"
      [maxlength]="maxLength ?? number.MAX_VALUE"
      [formControl]="textAreaControl"
      [rows]="rows"
      [readOnly]="readonly"
      [ngClass]="borderColorClass"
      class="primary-field"
      placeholder="{{ placeholder }}"
      (input)="enforceLineLimit($event)"
      (keydown)="onKeyDown($event)"
      appTrackUnsavedField
      [trackingIsDisabled]="!displayChangeIndicator"
      [reset$]="reset$"
    ></textarea>
  </div>
  <div class="flex justify-between items-center mt-1">
    @if (maxRowAndLengthControlIsActive || maxLength) {
      <span class="text-sm text-gray-600"
        >{{ calculateTextLength(textAreaControl.value) }}/{{ maxLengthWithoutLineSeparators }}</span
      >
    } @else {
      <span class="text-sm text-gray-600">{{ textAreaControl.value.length || 0 }}</span>
    }
    @if (fieldIsRequired && textAreaControl.hasError('required') && textAreaControl.touched) {
      <span class="text-red-600 text-sm font-extralight">Field is required</span>
    }
    @if (textAreaControl.hasError('maxRowsExceeded')) {
      <span class="text-red-600 text-sm font-extralight">Maximum {{ maxRows }} rows allowed</span>
    }
    @if (textAreaControl.hasError('maxLengthPerRowExceeded')) {
      <span class="text-red-600 text-sm font-extralight"
        >Each row must be at most {{ maxLengthPerRow }} characters long</span
      >
    }
  </div>
</div>
